import { MapPinOff } from 'lucide-react';
import { Badge } from 'components/ui/badge';

/** The amber « not located » pill, beside the Banned one (record header, directory, logistics card). */
const UnlocatedBadge = ({ label }: { label: string }) => (
  <Badge
    variant="outline"
    className="w-fit gap-1 rounded-full border-amber-200 bg-amber-50 px-2 font-medium text-amber-800 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-300"
  >
    <MapPinOff className="h-3 w-3" aria-hidden="true" />
    {label}
  </Badge>
);

export default UnlocatedBadge;
